export const ChangeSiteInformation = (siteId, nomSite) => {
  return {
    type: "InformationChange",
    siteId: siteId,
    nomSite: nomSite,
  };
};
